import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=4bb52a2a&scoped=true&lang=pug"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb52a2a",
  null
  
)

export default component.exports